<template>
    <div class="container">
        <section class="section">
            <span class="is-size-4">Orders</span>
            <b-table :data="orders">
                <template slot-scope="props">
                    <b-table-column label="Email">
                        {{ props.row.email }}
                    </b-table-column>
                    <b-table-column label="Paid">
                        {{ props.row.paid }}
                    </b-table-column>
                    <b-table-column label="Phone Number">
                        {{ props.row.address.phone }}
                    </b-table-column>
                    <b-table-column label="Postal Code">
                        {{ props.row.address.postal_code }}
                    </b-table-column>
                </template>
            </b-table>
        </section>
    </div>
</template>

<script>
import BTable from 'buefy/src/components/table/Table';
import BTableColumn from 'buefy/src/components/table/TableColumn';

export default {
  components: {
    BTableColumn,
    BTable,
  },

  name: 'admin-orders',

  mounted() {
    this.$store.dispatch('order/load');
  },

  computed: {
    loading() {
      return this.$store.state.order.loading;
    },

    orders() {
      return this.$store.state.order.orders;
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/admin/AdminOrders.vue